import React from 'react';
import { MainLayout } from '@components';
import AllergyComponents from './Allergy';

export default function AllergyPage(props) {
  return (
    <MainLayout footer="main" children={<AllergyComponents {...props} />} />
  );
}
